import * as React from 'react';
import Icon from '../../../common/icons/Icon';
import css from './ServiceFooterAccordion.module.scss';

interface Props extends React.HTMLProps<{}> {
  name: string;
  copy: string;
}

const ServiceFooterAccordion = (props: Props) => {
  return (
    <div className={css.ServiceFooterAccordion}>
      <input
        id={props.name}
        type="checkbox"
        className={css.ServiceFooterAccordion__Input}
      />
      <label htmlFor={props.name} className={css.ServiceFooterAccordion__Head}>
        <div className={css.ServiceFooterAccordion__Head__Brand}>
          <span className={css.ServiceFooterAccordion__Head__Copy}>
            {props.copy}
          </span>
        </div>
        <Icon
          name="descend-gr"
          className={css.ServiceFooterAccordion__Head__Icon}
        />
      </label>
      <div className={css.ServiceFooterAccordion__Show}>{props.children}</div>
    </div>
  );
};

export default ServiceFooterAccordion;
